import script from "./SchoolSearchSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./SchoolSearchSelect.vue?vue&type=script&setup=true&lang=ts"

import "./SchoolSearchSelect.vue?vue&type=style&index=0&id=25df874a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25df874a"]])

export default __exports__